module.exports = __webpack_public_path__ + "static/img/XR2.ae045dbc.png";